"use client";
let i = /* @__PURE__ */ function(t) {
  return t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t;
}({});
const n = {
  tabActivationDirection: (t) => ({
    [i.activationDirection]: t
  })
};
export {
  n as t
};
